// extracted by mini-css-extract-plugin
export default {"input":"ReponseLibre_input__ZUOIf","div":"ReponseLibre_div__z+Q3r","btn":"ReponseLibre_btn__Oy2O1"};